export default __webpack_public_path__ + "static/media/logout.443d7419.svg";